import { loadScript } from '@/utils/index';

// 域名到 GA4 测量 ID 的映射
const DOMAIN_GA4_CONFIG: Record<string, string> = {
    'heytapimg.com': 'G-E2TBH07HB5',
    'actimg.heytapimg.com': 'G-E2TBH07HB5',
    'lsmagazineimg.com': 'G-S39C1XW1CQ',
    'contents.lsmagazineimg.com': 'G-S39C1XW1CQ',
};

/**
 * 初始化 GA4 数据层和 gtag 函数
 * @param measurementId GA4 测量 ID
 */
const initGA4DataLayer = (measurementId: string): void => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
};

export const initGoogleAnalyticsSDK = (): void => {
    // 获取当前域名和对应的 GA4 测量 ID
    const domain = window.location.hostname;
    const measurementId = DOMAIN_GA4_CONFIG[domain];

    if (!measurementId) {
        console.warn(`No GA4 config found for domain: ${domain}`);
        return;
    }

    // 初始化 GA4 数据层和 gtag 函数
    initGA4DataLayer(measurementId);

    // 创建 script 标签加载 GA4 SDK
    loadScript({
        src: `https://www.googletagmanager.com/gtag/js?id=${measurementId}`,
        scriptId: 'google-analytics',
        async: true,
        crossOrigin: 'anonymous',
    });
};
